// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){
 
  //wait until images, links, fonts, stylesheets, and js is loaded
  window.addEventListener("load", function() {
    
    /* Tab Filter Optionen einfügen */
    const allTabsBlocks = document.querySelectorAll('.tabs');

    allTabsBlocks.forEach(tabsBlock => {
      const allTabsItems = tabsBlock.querySelectorAll('.tabs-item');
      const tabFilterList = tabsBlock.querySelector('.tab-navigation');
      allTabsItems.forEach(tabsItem => {
        const tabTitle = tabsItem.getAttribute('data-tabtitle');
        /* Erstelle Filter-Button und füge ihn in die Filter-Liste ein */
        const tabFilterButton = document.createElement('button');
        tabFilterButton.classList.add('tablinks');
        tabFilterButton.textContent = tabTitle;
        tabFilterList.appendChild(tabFilterButton);
        /* Füge Click-Event-Listener hinzu */
        tabFilterButton.addEventListener('click', function() {
          /* Entferne alle aktiven Tabs */
          allTabsItems.forEach(item => {
            item.classList.remove('active');
          });
          /* Füge aktiven Tab hinzu */
          tabsItem.classList.add('active');
          /* Entferne alle aktiven Filter-Buttons */
          tabFilterList.querySelectorAll('.tablinks').forEach(button => {
            button.classList.remove('active');
          });
          /* Füge aktiven Filter-Button hinzu */
          tabFilterButton.classList.add('active');
        });
      });
      /* Setze den ersten Tab auf aktiv */
      if (allTabsItems.length > 0) {
        allTabsItems[0].classList.add('active');
        const firstTabButton = tabFilterList.querySelector('.tablinks');
        if (firstTabButton) {
          firstTabButton.classList.add('active');
        }
      }
    });

   }, false);
 
 });